import { IconButton, Tooltip } from '@material-ui/core';
import React from 'react';

interface IconButtonWithTooltipProps {
  size: 'small' | 'medium' | undefined;
  tooltip?: string;
  handleClick?: (evt: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  children?: React.ReactNode;
  edge: 'start' | 'end';
}

export const IconButtonWithTooltip = ({
  size,
  tooltip = 'No description is supported',
  handleClick,
  children,
  edge,
}: IconButtonWithTooltipProps) => (
  <Tooltip title={tooltip}>
    <IconButton size={size} onClick={handleClick} edge={edge}>
      {children}
    </IconButton>
  </Tooltip>
);
